import { NavLink, Outlet } from "react-router-dom";
import { Sparkles, Home, FileText, Users, TrendingUp, PenTool, Mail, Settings as Cog } from "./components/icons.jsx";

const NAV = [
  { to: "/", label: "Overview", icon: Home, end: true },
  { to: "/posts", label: "My Posts", icon: FileText },
  { to: "/competitors", label: "Competitors", icon: Users },
  { to: "/trending", label: "Trending", icon: TrendingUp },
  { to: "/draft", label: "AI Draft", icon: PenTool },
  { to: "/newsletter", label: "Newsletter", icon: Mail },
  { to: "/settings", label: "Settings", icon: Cog }
];

export function App() {
  return (
    <div className="min-h-screen flex">
      <aside className="w-60 shrink-0 bg-bg-1 border-r border-white/5 p-4 hidden md:flex flex-col">
        <div className="flex items-center gap-2 mb-8 px-2">
          <Sparkles className="w-5 h-5 text-brand-500" />
          <span className="font-semibold tracking-tight">LinkedIn AI</span>
        </div>
        <nav className="space-y-1">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium transition ${
                  isActive ? "bg-white/10 text-white" : "text-slate-400 hover:text-white hover:bg-white/5"
                }`
              }
            >
              <item.icon className="w-4 h-4" />
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="mt-auto pt-4 text-xs text-slate-500">
          Personal use only. Treat data with care.
        </div>
      </aside>
      <main className="flex-1 overflow-x-hidden">
        <div className="max-w-6xl mx-auto px-6 py-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
